import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { WelcomeInput } from "@core/types";
import * as api from "./api";

const key = ["portal", "welcome-content"] as const;

// Singleton (SPEC-205 §2/§5): una sola clave, sin filtro ni paginación.
export const useWelcome = () =>
  useQuery({ queryKey: key, queryFn: api.getWelcome });

export function useWelcomeMutations() {
  const client = useQueryClient();
  const invalidate = () => client.invalidateQueries({ queryKey: key });
  return {
    edit: useMutation({
      mutationFn: (input: WelcomeInput) => api.editWelcome(input),
      onSuccess: invalidate,
    }),
  };
}
